import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import ThemeToggle from './ThemeToggle';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleSmoothScroll = (id) => {
    const element = document.querySelector(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      setIsMenuOpen(false); // Close the mobile menu after clicking
    }
  };

  return (
    <nav className="sticky top-0 z-10 bg-background-light dark:bg-background-dark text-text-light dark:text-text-dark shadow-md">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <Link to="/" className="text-2xl font-bold">
          <span className="text-primary-light dark:text-primary-dark">Sebastián Glonek</span>
        </Link>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2 focus:outline-none"
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? (
            <FaTimes className="text-text-light dark:text-text-dark" />
          ) : (
            <FaBars className="text-text-light dark:text-text-dark" />
          )}
        </button>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-6">
          <button onClick={() => handleSmoothScroll('#about')} className="hover:text-primary-light dark:hover:text-primary-dark transition-colors">About</button>
          <button onClick={() => handleSmoothScroll('#projects')} className="hover:text-primary-light dark:hover:text-primary-dark transition-colors">Projects</button>
          <button onClick={() => handleSmoothScroll('#contact')} className="hover:text-primary-light dark:hover:text-primary-dark transition-colors">Contact</button>

          <ThemeToggle />
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-background-light dark:bg-background-dark border-t border-gray-200 dark:border-gray-700">
          <div className="container mx-auto px-4 py-3 flex flex-col space-y-3">
            <button
              onClick={() => handleSmoothScroll('#about')}
              className="py-2 hover:text-primary-light dark:hover:text-primary-dark transition-colors"
            >
              About
            </button>
            <button
              onClick={() => handleSmoothScroll('#projects')}
              className="py-2 hover:text-primary-light dark:hover:text-primary-dark transition-colors"
            >
              Projects
            </button>
            <button
              onClick={() => handleSmoothScroll('#contact')}
              className="py-2 hover:text-primary-light dark:hover:text-primary-dark transition-colors"
            >
              Contact
            </button>
            <div className="py-2 flex justify-between items-center">
              <span>Theme</span>
              <ThemeToggle />
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;